/* tslint:disable */
/* eslint-disable */
/**
 * Ampersand public API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * The access token for the connection.
 * @export
 * @interface Oauth2AuthorizationCodeTokensOnlyAccessToken
 */
export interface Oauth2AuthorizationCodeTokensOnlyAccessToken {
    /**
     * 
     * @type {string}
     * @memberof Oauth2AuthorizationCodeTokensOnlyAccessToken
     */
    token: string;
    /**
     * 
     * @type {Date}
     * @memberof Oauth2AuthorizationCodeTokensOnlyAccessToken
     */
    issuedAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof Oauth2AuthorizationCodeTokensOnlyAccessToken
     */
    expiresAt?: Date;
}

/**
 * Check if a given object implements the Oauth2AuthorizationCodeTokensOnlyAccessToken interface.
 */
export function instanceOfOauth2AuthorizationCodeTokensOnlyAccessToken(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "token" in value;

    return isInstance;
}

export function Oauth2AuthorizationCodeTokensOnlyAccessTokenFromJSON(json: any): Oauth2AuthorizationCodeTokensOnlyAccessToken {
    return Oauth2AuthorizationCodeTokensOnlyAccessTokenFromJSONTyped(json, false);
}

export function Oauth2AuthorizationCodeTokensOnlyAccessTokenFromJSONTyped(json: any, ignoreDiscriminator: boolean): Oauth2AuthorizationCodeTokensOnlyAccessToken {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'token': json['token'],
        'issuedAt': !exists(json, 'issuedAt') ? undefined : (new Date(json['issuedAt'])),
        'expiresAt': !exists(json, 'expiresAt') ? undefined : (new Date(json['expiresAt'])),
    };
}

export function Oauth2AuthorizationCodeTokensOnlyAccessTokenToJSON(value?: Oauth2AuthorizationCodeTokensOnlyAccessToken | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'token': value.token,
        'issuedAt': value.issuedAt === undefined ? undefined : (value.issuedAt.toISOString()),
        'expiresAt': value.expiresAt === undefined ? undefined : (value.expiresAt.toISOString()),
    };
}

